import React, { Component } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import HeaderBar from "../components/headerBar";
import FooterSection from "../components/footerSection";

class Layout extends Component {
  render() {
    const { headerBrand, footerMargin, footerPadding, layoutClassName } = this.props;

    return(  
      <div className={"layout " + layoutClassName}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>bld.ai</title>
          <link rel="canonical" href="https://www.bld.ai/" />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"/>
        </Helmet>
        <HeaderBar brand={headerBrand} />
        <div id="content">
          {this.props.children}
        </div>
        <FooterSection
          withMargin={footerMargin}
          withPadding={footerPadding}
        />
      </div>
    );
  }
}

Layout.propTypes = {
  headerBrand: PropTypes.string,
  footerMargin: PropTypes.bool,
  footerPadding: PropTypes.bool,
}

Layout.defaultProps = {
  headerBrand: 'BLD.AI',
  footerMargin: true,
  footerPadding: true,
}

export default (Layout);